module.exports = {
	"id": "ML",
	"name": "Mali",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.001442,
			"5": 0.000721,
			"6": null,
			"7": null,
			"8": 0.000721,
			"9": null,
			"10": 0.000721,
			"11": 0.04326,
			"12": null,
			"13": null,
			"14": 0.000721,
			"15": 0.002163,
			"16": 0.002163,
			"17": 0.001442,
			"18": 0.001442,
			"19": 0.000721,
			"20": 0.001442,
			"21": null,
			"22": 0.004326,
			"23": null,
			"24": null,
			"25": 0.00721,
			"26": 0.015862,
			"27": 0.002163,
			"28": 0.002163,
			"29": 0.022351,
			"30": 0.001442,
			"31": 0.00721,
			"32": 0.001442,
			"33": 0.016583,
			"34": 0.002163,
			"35": 0.001442,
			"36": 0.002884,
			"37": 0.001442,
			"38": 0.005768,
			"39": 0.005768,
			"40": 0.02163,
			"41": null,
			"42": 0.000721,
			"43": 0.015862,
			"44": 0.002884,
			"45": 0.022351,
			"46": 0.002163,
			"47": 0.018746,
			"48": 0.004326,
			"49": 0.155015,
			"50": 0.011536,
			"51": 0.043981,
			"52": 0.051191,
			"53": 1.39153,
			"54": 0.3605,
			"55": 0.005768,
			"56": 0.001442,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.616455,
			"4": 0.002884,
			"5": 0.000721,
			"6": 0.000721,
			"7": 0.001442,
			"8": 0.006489,
			"9": 0.001442,
			"10": 0.002884,
			"11": 0.006489,
			"12": 0.006489,
			"13": 0.002884,
			"14": 0.004326,
			"15": 0.001442,
			"16": 0.012257,
			"17": 0.002884,
			"18": 0.003605,
			"19": 0.005768,
			"20": 0.007931,
			"21": 0.004326,
			"22": 0.009373,
			"23": 0.003605,
			"24": 0.002163,
			"25": 0.005768,
			"26": 0.005768,
			"27": 0.000721,
			"28": 0.012257,
			"29": 0.020188,
			"30": 0.041818,
			"31": 0.012257,
			"32": 0.006489,
			"33": 0.007931,
			"34": 0.008652,
			"35": 0.002884,
			"36": 0.009373,
			"37": 0.020188,
			"38": 0.01442,
			"39": 0.015862,
			"40": 0.02884,
			"41": 0.012257,
			"42": 0.02163,
			"43": 0.113918,
			"44": 0.047586,
			"45": 0.028119,
			"46": 0.015141,
			"47": 0.160783,
			"48": 0.212695,
			"49": 1.018052,
			"50": 0.031003,
			"51": 0.002884,
			"52": null,
			"3.5": 0.005768,
			"3.6": 0.003605
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.000721,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.001442,
			"30": null,
			"31": null,
			"32": 0.002163,
			"33": null,
			"34": null,
			"35": 0.134106,
			"36": 0.001442,
			"37": 0.01442,
			"38": 0.005768,
			"39": 0.015862,
			"40": 0.085799,
			"41": 0.009373,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.003605,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.003605
		},
		"safari": {
			"0": null,
			"4": 0.000721,
			"5": 0.002163,
			"6": 0.006489,
			"7": 0.007931,
			"8": 0.118244,
			"9": 0.011536,
			"10": 0.069216,
			"3.1": null,
			"3.2": null,
			"5.1": 0.023072,
			"6.1": 0.001442,
			"7.1": 0.015141,
			"9.1": 0.065611
		},
		"ios_saf": {
			"8": 0,
			"10": 0.494761533722,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0133332508326,
			"8.1-8.4": 0.024632615945,
			"9.0-9.2": 0.0117513397169,
			"9.3": 0.179283259784
		},
		"android": {
			"3": 0,
			"4": 0.113457953488,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.014182244186,
			"4.1": 0.409259046512,
			"4.2-4.3": 1.02314761628,
			"4.4": 2.34614839535,
			"4.4.3-4.4.4": 2.36640874419
		},
		"ie": {
			"6": 0.000725546027743,
			"7": 0.0108831904161,
			"8": 0.0906932534678,
			"9": 0.028296295082,
			"10": 0.0471604918033,
			"11": 0.397599223203,
			"5.5": null
		},
		"op_mob": {
			"0": 1.0494431916,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0291511997668
		},
		"edge": {
			"12": 0.039655,
			"13": 0.052633,
			"14": 0.033166
		},
		"ie_mob": {
			"10": 0.115268704225,
			"11": 0.469308295775
		},
		"bb": {
			"7": 0.00695925,
			"10": null
		},
		"samsung": {
			"0": 1.985706
		},
		"and_uc": {
			"0": 51.099453
		},
		"op_mini": {
			"0": 14.1389656086
		},
		"and_chr": {
			"0": 15.255424
		},
		"and_ff": {
			"0": 0.389718
		}
	},
	"total": 97.69670825
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/ML.json
 ** module id = 589
 ** module chunks = 0
 **/